export const currentPeriod = (startDate: number, endDate: number) => {
  const currentDate = new Date()

  const start = new Date(startDate).getTime()
  const end = new Date(endDate).getTime()
  const current = currentDate.getTime()

  return current >= start && current <= end
}
